import { restApiClient } from '@/datasources';

export type SignInResponse = {
  access_token: string;
  refresh_token: string;
  status?: number;
};

type ForgotPasswordResponse = {
  email: string;
};

type isPendingEmailValidationResponse = {
  isPendingValidation: boolean;
  isProfessional?: boolean;
  customer: {
    name: string;
    socialName: string;
    documentNumber: string;
    email: string;
    location: {
      city: string;
      state: string;
    };
    phone: string;
    birthday: string;
  };
  maskedEmail: string;
  token: string;
};

export async function login(username: string, password: string): Promise<SignInResponse> {
  const { data: signInResponse } = await restApiClient.post<SignInResponse>(
    'public/auth/signin',
    { username, password },
    { headers: { Environment: 'online' } },
  );
  return signInResponse;
}

export async function forgotPassword(documentNumber: string): Promise<ForgotPasswordResponse> {
  const { data: forgotPasswordResponse } = await restApiClient.post<ForgotPasswordResponse>(
    'public/auth/forgot-password',
    {
      documentNumber,
    },
  );

  return forgotPasswordResponse;
}

export async function isPendingEmailValidation(
  documentNumber: string,
  password: string,
): Promise<isPendingEmailValidationResponse> {
  const { data: isPendingEmailValidationResponse } = await restApiClient.post<isPendingEmailValidationResponse>(
    'v2/online/customers/is-pending-email-validation',
    {
      documentNumber,
      password,
    },
  );
  return isPendingEmailValidationResponse;
}
